import { render, staticRenderFns } from "./partnerInformation.vue?vue&type=template&id=51c58d11&scoped=true&"
import script from "./partnerInformation.vue?vue&type=script&lang=js&"
export * from "./partnerInformation.vue?vue&type=script&lang=js&"
import style0 from "./partnerInformation.vue?vue&type=style&index=0&id=51c58d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c58d11",
  null
  
)

export default component.exports